import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import { CleanIcon } from 'assets/icons';
import { ReportService } from 'services';
import moment from 'moment';

interface Props extends RootState {}

const INITIAL_STATE = {
  search: '',
  status: '',
};

const HISTORY_TYPES = {
  REVISION: 1,
  SIGNATURE: 2,
  PREPARATION: 3,
  FORMALITIES: 4,
};

const TYPE_NAME = {
  [HISTORY_TYPES.REVISION]: 'Revisión Documental',
  [HISTORY_TYPES.SIGNATURE]: 'Firma Electrónica',
  [HISTORY_TYPES.PREPARATION]: 'Elaboración de documentos',
  [HISTORY_TYPES.FORMALITIES]: 'Trámites automatizados',
};

const STATUS_FILTER = {
  [HISTORY_TYPES.REVISION]: [
    { value: Constants.REVISION_STATUS.PENDING, label: 'En Revisión' },
    { value: Constants.REVISION_STATUS.ACCEPTED, label: 'Aprobadas' },
    { value: Constants.REVISION_STATUS.REJECTED, label: 'Rechazadas' },
    { value: Constants.REVISION_STATUS.FINISHED, label: 'Finalizadas' },
  ],
  [HISTORY_TYPES.SIGNATURE]: [
    { value: Constants.SIGNATURE_STATUS.PENDING, label: 'En proceso' },
    { value: Constants.SIGNATURE_STATUS.ACCEPTED, label: 'Aceptadas' },
    { value: Constants.SIGNATURE_STATUS.REJECTED, label: 'Rechazadas' },
  ],
  [HISTORY_TYPES.PREPARATION]: [
    { value: Constants.PREPARATION_STATUS.PENDING, label: 'En revisión' },
    { value: Constants.PREPARATION_STATUS.FINISHED, label: 'Finalizadas' },
  ],
  [HISTORY_TYPES.FORMALITIES]: [],
};

class History extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'Nro. de ID',
      'Fecha',
      'Abogado',
      'Tipo de derecho',
      'Tipo de trámite',
      'Estatus',
    ],
    formalitiesHeader: [
      'Nro. de ID',
      'Fecha',
      'Tipo de derecho',
      'Tipo de trámite',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    type: '',
  };

  load = async (withoutLoading = false) => {
    if (this.state.type) {
      const res: any = await ReportService.getHistory({
        withoutLoading,
        page: this.state.page,
        ...this.state.form,
        user_id: this.props.user?.id,
        type: this.state.type,
      });
      this.setState({
        data: res.history.rows,
        last_page: res.history.count,
      });
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.REVISION_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.REVISION_STATUS.ACCEPTED:
        return Colors.green;
        break;

      case Constants.REVISION_STATUS.REJECTED:
        return Colors.danger;
        break;
    }
  };

  render() {
    return (
      <div id="client-reports-history">
        <div className="row row-filter">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <Input
                  value={this.state.form.search}
                  name="search"
                  label="Buscar"
                  placeholder="Buscar"
                  className="input-table"
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className="col-md-3">
                <Select
                  color="white"
                  placeholder="Seleccionar"
                  label="Tipo de trámite"
                  name="type"
                  onChange={(e: any) =>
                    this.setState({ type: e.target.value }, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.type}
                  options={[
                    {
                      value: HISTORY_TYPES.REVISION.toString(),
                      label: 'Revisión Documental',
                    },
                    {
                      value: HISTORY_TYPES.SIGNATURE.toString(),
                      label: 'Firma Electrónica',
                    },
                    {
                      value: HISTORY_TYPES.PREPARATION.toString(),
                      label: 'Elaboración de documentos',
                    },
                    {
                      value: HISTORY_TYPES.FORMALITIES.toString(),
                      label: 'Trámites automatizados',
                    },
                  ]}
                />
              </div>
              {this.state.type !== HISTORY_TYPES.FORMALITIES.toString() && (
                <div className="col-md-3">
                  <Select
                    color="white"
                    placeholder="Seleccionar"
                    label="Estatus"
                    name="status"
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.load(true);
                      })
                    }
                    value={this.state.form.status}
                    /* @ts-ignore */
                    options={STATUS_FILTER[this.state.type] ?? []}
                  />
                </div>
              )}
              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {this.state.type ? (
          <>
            <Table
              title=""
              data={this.state.data.length}
              header={
                this.state.type === HISTORY_TYPES.FORMALITIES.toString()
                  ? this.state.formalitiesHeader
                  : this.state.header
              }
            >
              {this.state.data.map((i: any, index: number) => {
                return (
                  <tr key={index}>
                    <td>{i.number || i?.number_format}</td>
                    <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                    {this.state.type !==
                      HISTORY_TYPES.FORMALITIES.toString() && (
                      <td>{i.lawyer?.full_name || '-'}</td>
                    )}
                    <td>{i.area?.name || '-'}</td>
                    {/* @ts-ignore */}
                    <td>{TYPE_NAME[this.state.type]}</td>
                    {this.state.type !==
                      HISTORY_TYPES.FORMALITIES.toString() && (
                      <td
                        className="status"
                        style={{ color: this.getColor(i) }}
                      >
                        {i.status_text}
                      </td>
                    )}
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.last_page}
              active={this.state.page}
              onChange={async (page: number) => {
                await this.setState({
                  page: page,
                });
                this.load();
              }}
            />
          </>
        ) : (
          <div className="text-center">
            <p className="no-type">
              Seleccione el tipo de trámite que desea ver
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(History);
